<template>
  <div class="brand-list">
    <div class="icon-link-slider">
      <h3 class="section-title">{{ title }}</h3>
      <loading :active.sync="isLoading" :is-full-page="false" style="z-index: 0"></loading>
      <div class="brand-box">
        <div class="icon-link-banner">
          <div class="link-item" v-for="item in brands"
               :key="item.index">
            <div class="item-icon">
              <div class="item-icon__image">
                <a v-bind:href="item.tb_url" target="_blank">
                  <img :src="item.tb_pic" :alt="item.tb_name" width="50px" height="50px"/>
                </a>
              </div>
            </div>
            <a v-bind:href="item.tb_url" target="_blank">
              <div class="item-icon__title">{{ item.tb_name }}</div>
            </a>
          </div>
        </div>
      </div>
      <div class="back" v-if="brands.length > 0">
        <v-btn class="v-btn-primary" color="primary" outlined @click="back">
          返回
        </v-btn>
      </div>
    </div>
  </div>
</template>
BrandIconSlider
<script>

export default {
  name: 'CategoryBrandList',
  props: {
    brandsList: {},
  },
  data: () => ({
    brands: {},
    isLoading: true,
    title: ''
  }),
  created() {
    axios.get('/ticket/api/category/brand/list/' + this.$route.query.category)
    .then((response) => {
      this.brands = response.data;
      this.title = response.data[0]['tb_category_name'];
      this.isLoading = false;
    })
  },
  methods: {
    back() {
      this.$router.replace({ name: 'homepage' })
    },
  },
}
</script>

<style lang="scss" scoped>
.section-title {
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.56px;
  color: #383838;
  margin-bottom: 10px;
  margin-top: 10px;
}
.icon-link-slider {
  border-radius: 16px;
  margin-bottom: 5px;
  .icon-link-banner {
    display: flex;
    width: 100%;
    position: relative;
    flex-wrap: wrap;
    padding: 20px 0;

    .link-item {
      text-align: center;
      display: inline-block;
      width: 33.3333%;
      margin-bottom: 20px;

      .item-icon {
        text-align: center;
        width: 84px;
        margin: 0 auto 5px auto;

        &__image {
          justify-content: center;
          align-items: center;
          background: white;
          height: 50px;
          width: 50px;
          border-radius: 1000px;
          margin: auto;
          overflow: hidden;
          background-size: contain;
          img {
            width: 100%;
          }
        }

        &__title {
          width: 84px;
          text-align: center;
          margin: auto;
          font-size: 14px;
          letter-spacing: 0.44px;
          text-align: center;
          color: #383838;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }

  ::v-deep .v-carousel {
    border-radius: 16px;
    z-index: 0;
    .v-carousel__controls {
      height: 25px;
      .v-item-group {
        .v-carousel__controls__item.v-btn {
          margin: 0 5px 0 0;
          width: 5px;
          height: 5px;
          background: #bbbbbb;
          opacity: 1;

          &.v-btn--active {
            background: #767676;
          }

          &::before {
            opacity: 0;
          }
        }
      }
    }
  }
}
.brand-list {
  padding: 0px 4.8%;
  width: 100%;
  margin-bottom: 20px;
  background-color: #ffffff;
  margin-top: 10px;
}

.brand-box {
  display: grid;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  grid-auto-rows: minmax(100px, auto);
  margin-top: 10px;
}

.back {
  margin-top: 20px;
}
</style>